import { Upload, Popover, Button } from 'element-ui';
import { MIME_TYPES } from './mime-types';

export default {
    name: 'FileListAnswer',
    props: {
        id: [Number, String],
        value: Array,
        label: String,
        label_class: { type: String, default: '' },
        disabled: Boolean,
        visible: { type: Boolean, default: true },
        hint: String,
        error_messages: Array,
        hint_type: { type: String, default: 'warning' },
        preview: { type: Boolean, default: false },
        valid: { type: Boolean, default: true },
        is_mandatory: Boolean,
        is_mandatory_if_visible: Boolean,
        max_length: { type: Number, default: 0 }, //count
        only_images: Boolean,
        max_size: Number, //mb

        smallest: { type: String, default: 'col-12' },
        small: { type: String, default: 'col-sm-12' },
        medium: { type: String, default: 'col-md-12' },
        large: { type: String, default: 'col-lg-12' },
        largest: { type: String, default: 'col-xl-12' },
        accepted_formats: Array,
        preview_API: { type: Function, default: null },
        open_inline: { type: Boolean, default: false }
    },
    components: {
        [Upload.name]: Upload,
        [Popover.name]: Popover,
        [Button.name]: Button
    },
    computed: {
        column_class() {
            return `${this.largest} ${this.large} ${this.medium} ${this.small} ${this.smallest} mt-3`
        },
        label_class_value() {
            return "float-left"
        },
        is_upload_available() {
            return (!this.prop_value || this.prop_value.length < this.max_length) && !this.disabled
        }
    },
    watch: {
        value: { // watch it
            immediate: true,
            handler(val, oldVal) {
                this.prop_value = val != null ? val : [];
            }
        }
    },
    data() {
        return {
            warning_length: "",
            warning_mandatory: "This field is mandatory to fill",

            prop_value: [],
            prop_valid: true,

            files_types: '',
            isProcessing: false 
        };
    },
    methods: {
        validate() {
            let new_warnings = [];
            if (this.is_mandatory && (!this.prop_value || !this.prop_value.length)) {
                new_warnings.push("This field is mandatory to fill. Please upload a file.");
            }

            this.prop_valid = !new_warnings.length;
            this.$emit("update:valid", this.prop_valid);
            this.$emit("update:error_messages", new_warnings);
        },
        is_file_valid(file, fileList) {
            let result = null;

            if (file && file.name) {
                if (this.accepted_formats && this.accepted_formats.length) {
                    this.accepted_formats.forEach(format => {
                        if (!result && file.name.endsWith(format)) {
                            result = true;
                        }
                    });
                }
            }

            if (!result) {
                this.load_file(false, file, fileList);
                return;
            }

            try {
                if (result) {
                    let ready = false;
                    let result = '';
                    const self = this;
                    const check = function () {
                        if (ready) {
                            self.load_file(result, file, fileList);
                            return;
                        }
                        setTimeout(check, 1000);
                    }
                    check();

                    const reader = new FileReader();
                    reader.onloadend = function (evt) {
                        result = evt.target.result; ready = true;
                    };
                    reader.readAsArrayBuffer(file.raw);
                }
            } catch (e) {
                this.$showError("Error while reading file. File is invalid.");
                result = false;
                this.load_file(false, file, fileList);
            }
        },
        handler_remove(file, fileList) {
            this.prop_value = fileList;
            this.update_sync_props();
        },
        load_file(fileData, newFile, fileList) {
            if (!fileData || fileData.byteLength / (1024 * 1024) > this.max_size) {
                if (!fileData) {
                    this.$showError("File is not valid or file format is not acceptable")
                } else {
                    this.$showError(`File length is more than ${this.max_size}MB, please use another file`)
                }

                fileList = fileList.filter(x => { return x.url != newFile.url });
            }
            else {
                newFile.itemContentString = this.arrayBufferToBase64String(fileData);
            }
            this.prop_value = fileList;
            this.update_sync_props();
        },
        handler_change(newFile, fileList) {
            this.is_file_valid(newFile, fileList);
        },
        update_sync_props() {
            this.validate();
            this.$emit("update:value", this.prop_value);
        },
        arrayBufferToBase64String(buffer) {
            let binaryString = ''
            const bytes = new Uint8Array(buffer);
            for (let i = 0; i < bytes.byteLength; i++) {
                binaryString += String.fromCharCode(bytes[i]);
            }

            return window.btoa(binaryString);
        },
        async handler_preview(file) {
            self = this;
            if (!file.itemContentString && (self.preview_API || typeof self.preview_API === "function")) {//this case currently works for club standards module(if have uploaded large files, and we need to download its)
                self.isProcessing = true;
                await self.preview_API(file.id)
                    .then(response => {
                        self.isProcessing = false;
                        if (!(response && response.body && response.body.isSuccess)) {
                            if (response && response.body && response.body.message) {
                                self.$showError(response.body.message);
                            } else {
                                self.$showError();
                            }
                        }
                        file.itemContent = response.body.outputData.fileAnswer;
                    },
                        () => {
                            self.isProcessing = false;
                            self.$showError();
                        });
            }
            //
            if (!file.url && file.itemContent) {
                try {
                    const mimeType = this.open_inline ? this.getMimeType(file.name) : 'application/octet-stream';
                    const blob = new Blob([this.base64ToArrayBuffer(file.itemContent)], { type: mimeType });
                    file.url = window.URL.createObjectURL(blob);
                } catch (err) {
                    this.$showError("Error while downloading file")
                }
            }
            if (file.url) {
                if (this.open_inline) {
                    window.open(file.url, '_blank');
                } else {
                    const link = document.createElement('a');
                    link.href = file.url;
                    link.download = file.name;
                    link.click();
                }
            }
            else {
                this.$showError("Can't save file. Data is missed.")
            }
        },
        getMimeType(name) {
            if (!name) return 'application/octet-stream';
            const ext = name.split('.').pop().toLowerCase();
            return MIME_TYPES[ext] || 'application/octet-stream';
        },
        base64ToArrayBuffer(base64) {
            const binary_string = window.atob(base64);
            const len = binary_string.length;
            const bytes = new Uint8Array(len);
            for (let i = 0; i < len; i++) {
                bytes[i] = binary_string.charCodeAt(i);
            }
            return bytes;
        },
        handler_before_upload(file) {
            //if (this.max_size)
        },
        remove_tab_index() {
            if (this.$refs && Object.keys(this.$refs).length) {
                Object.keys(this.$refs).forEach(prop => {
                    if (this.$refs[prop] && this.$refs[prop].$el && this.$refs[prop].$el.children && this.$refs[prop].$el.children.length) {
                        this.$refs[prop].$el.children[1].tabIndex = -1;
                    }
                })
            }
        },
    },
    mounted() {
        //this.warning_length = `You can upload maximum ${this.max_length} items`;
        this.files_types = "Any";
        //this.files_types = "Jpeg or png";
        //if (!this.only_images) {
        //    
        //}
        if (this.accepted_formats && this.accepted_formats.length) {
            this.files_types = "";
            this.accepted_formats.forEach(format => {
                this.files_types += ", " + format;
            })
            this.files_types = this.files_types.substring(2, this.files_types.length);
        }

        this.update_sync_props();
        this.remove_tab_index();
    }
};



// WEBPACK FOOTER //
// ./src/components/shared/answer-types/file-list/file-list.js